import { useEffect, useState } from 'react';

/**
 * Index range (inclusive) into a daily series for chart/matrix views.
 * Resets to the full span when the report changes (`resetKey`) or when the series length changes.
 */
export function useParityReportDateRange(seriesLength: number, resetKey: unknown) {
  const [dateRange, setDateRange] = useState<Array<number>>(() => [
    0,
    Math.max(0, seriesLength - 1),
  ]);

  useEffect(() => {
    setDateRange([0, Math.max(0, seriesLength - 1)]);
  }, [resetKey, seriesLength]);

  return { dateRange, setDateRange };
}
